if (!customElements.get('similar-products-carousel')) {
  class SimilarProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.slider');
      this.previousButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.currentCounter = this.querySelector('.slider-counter--current');
      this.totalCounter = this.querySelector('.slider-counter--total');
      if (!this.slider || !this.previousButton || !this.nextButton) return;

      this.slides = Array.from(this.slider.querySelectorAll('.slider__slide'));
      if (this.slides.length < 2) return;
      this.interval = 4000;

      this.previousButton.addEventListener('click', () => { this.move(-1); this.restart(); });
      this.nextButton.addEventListener('click', () => { this.move(1); this.restart(); });
      this.slider.addEventListener('scroll', () => this.updateCounter(), { passive: true });
      this.slider.addEventListener('pointerdown', () => this.stop(), { passive: true });
      this.slider.addEventListener('pointerup', () => this.start(), { passive: true });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.updateCounter();
      this.start();
    }

    stepSize() {
      const styles = getComputedStyle(this.slider);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return this.slides[0].getBoundingClientRect().width + gap;
    }

    move(direction) {
      const atStart = this.slider.scrollLeft <= 2;
      const atEnd = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth - 2;
      if (direction > 0 && atEnd) this.slider.scrollTo({ left: 0, behavior: 'smooth' });
      else if (direction < 0 && atStart) this.slider.scrollTo({ left: this.slider.scrollWidth, behavior: 'smooth' });
      else this.slider.scrollBy({ left: direction * this.stepSize(), behavior: 'smooth' });
    }

    updateCounter() {
      if (!this.currentCounter || !this.totalCounter) return;
      const index = Math.round(this.slider.scrollLeft / this.stepSize()) + 1;
      this.currentCounter.textContent = Math.min(Math.max(index, 1), this.slides.length);
      this.totalCounter.textContent = this.slides.length;
    }

    start() {
      this.stop();
      if (this.slider.scrollWidth <= this.slider.clientWidth + 2) return;
      this.timer = window.setInterval(() => this.move(1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() { this.start(); }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('similar-products-carousel', SimilarProductsCarousel);
}
